<template>
  <div v-if="userStats" class="d-flex justify-content-evenly align-items-center mx-2">
    <div class="vip-box">VIP</div>
    <img class="coins-icon mx-2" :src="require('../../assets/icons/coin.png')">
        <div class="coins-text"> {{ userStats.TotalCoins }}</div>
<!--    <img v-if="this.getServiceIdMapNumber(user.Service) === 2" class="vip-logo"-->
<!--         :src="require(`../../brand/${brandConfig.brand}/assets/icons/vip-icon.webp`)">-->
  </div>
</template>

<script>
import {serviceIdMap} from "@/config";
import {mapState} from "vuex";

export default {
  name: "PlayerServiceBoxTwo",
  props: ['hasNoGameLogo', 'hasNoCoins'],
  computed: {
    ...mapState(['user', 'brandConfig', 'userStats'])
  },
  methods: {
    getServiceIdMapNumber(service) {
      return serviceIdMap.get(service)
    },
  }
}
</script>

<style scoped>
.vip-box {
  border-radius: 12.122px;
  color: #FFFFFF;
  width: 50px;
  background: #9E00B3;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.30);
}
.game-logo-icon {
  width: 115px;
  height: auto;
}
.coins-icon {
  height: 20px;
  width: auto;
  font-size: 14px;
}

.coins-text {
  color: #FFFFFF;
  font-weight: 700;
  margin-right: 8px;
  font-size: 30px;
}

.has-no-coins {
  width: 125px;
  height: 45px;
}

.coins-container {
  display: flex;
  align-items: center;
  justify-content: end;
  width: 125px;
}

.vip-logo {
  width: 75px;
  height: auto;

}
</style>
